import { gql } from '@apollo/client'

export const VARIANT_DATASET_JOBS_QUERY = gql`
    query VariantDatasetJobList {
        variantDatasetJobList {
            id,
            dataset_id,
            dataset_name,
            dataset_description,
            num_of_samples,
            state,
            start_date,
            end_date,
            filter_applied {
                sample_filter {
                    pheno_filter {
                        string_filters {
                            name
                            values
                        }
                        num_filters {
                            name
                            greater_or_equal_than
                            lower_or_equal_than
                        }
                        bool_filters {
                            name
                            value
                        }
                    }
                }
                variant_filter {
                    variant_format_filter {
                        string_filters {
                            name
                            values
                        }
                        num_filters {
                            name
                            greater_or_equal_than
                            lower_or_equal_than
                        }
                        bool_filters {
                            name
                            value
                        }
                    }
                    variant_info_filter {
                        string_filters {
                            name
                            values
                        }
                        num_filters {
                            name
                            greater_or_equal_than
                            lower_or_equal_than
                        }
                        bool_filters {
                            name
                            value
                        }
                    }
                    variant_frequencies_filter {
                        string_filters {
                            name
                            values
                        }
                        num_filters {
                            name
                            greater_or_equal_than
                            lower_or_equal_than
                        }
                        bool_filters {
                            name
                            value
                        }
                    }
                }
            }
        }
    }
`

export const VARIANT_DATABASE_JOBS_QUERY = gql`
    query VariantDatabaseJobList {
        variantDatabaseJobList {
            id,
            database_id,
            database_name,
            database_description,
            state,
            submitted_date,
            start_date,
            end_date
        }
    }
`

export const CANCEL_PENDING_JOB = gql`
    mutation CancelPendingJob($jobId: String!) {
        cancelPendingJob(job_id: $jobId)
    }
`

export const FILTER_OPTIONS_QUERY = gql`
    query FilterOptions($databaseId: String!) {
        filterOptions(database_id: $databaseId) {
            pheno_filter_options {
                string_filters {
                    name,
                    distinct_values,
                    fraction_non_missing
                },
                num_filters {
                    name,
                    min_value,
                    max_value,
                    fraction_non_missing
                },
                bool_filters {
                    name,
                    fraction_non_missing
                }
            },
            variant_format_filter_options {
                string_filters,
                num_filters,
                bool_filters
            },
            variant_frequencies_filter_options {
                string_filters,
                num_filters,
                bool_filters
            },
            variant_info_filter_options {
                string_filters {
                    name,
                    fraction_non_missing
                },
                num_filters {
                    name,
                    min_value,
                    max_value,
                    fraction_non_missing
                },
                bool_filters {
                    name,
                    fraction_non_missing
                }
            }
        }
    }
`

export const SUBMIT_DATASET_JOB = gql`
    mutation SubmitNewDataset($databaseId: String!, $datasetName: String!, $datasetVersion: String!, $datasetDescription: String!, $filters: DatasetFilterInput!) {
        submitNewDataset(parent_database_id: $databaseId, dataset_version: $datasetVersion, dataset_name: $datasetName, description: $datasetDescription, dataset_filter: $filters)
    }
`

export const REMAINING_SAMPLE_COUNT = gql`
    query RemainingSampleCount($databaseId: String!, $filter: DatasetFilterInput!) {
        remainingSampleCount(database_id: $databaseId, filter: $filter)
    }
`


export const DATASET_QUERY = gql`
    query Dataset($datasetId: String!) {
        dataset(dataset_id: $datasetId) {
            dataset_id,
            dataset_name
            public
            version
            parent_database_id
            reference_genome
            gene_count
            variant_count
            transcript_count
            description
            filter_applied {
                sample_filter {
                    pheno_filter {
                        string_filters {
                            name
                            values
                        }
                        num_filters {
                            name
                            greater_or_equal_than
                            lower_or_equal_than
                        }
                        bool_filters {
                            name
                            value
                        }
                    }
                }
                variant_filter {
                    variant_format_filter {
                        string_filters {
                            name
                            values
                        }
                        num_filters {
                            name
                            greater_or_equal_than
                            lower_or_equal_than
                        }
                        bool_filters {
                            name
                            value
                        }
                    }
                    variant_info_filter {
                        string_filters {
                            name
                            values
                        }
                        num_filters {
                            name
                            greater_or_equal_than
                            lower_or_equal_than
                        }
                        bool_filters {
                            name
                            value
                        }
                    }
                    variant_frequencies_filter {
                        string_filters {
                            name
                            values
                        }
                        num_filters {
                            name
                            greater_or_equal_than
                            lower_or_equal_than
                        }
                        bool_filters {
                            name
                            value
                        }
                    }
                }
            }
        }
    }
`

export const DATASET_LIST_QUERY = gql`
    query {
        datasetList {
            dataset_id
            public
            dataset_name
            version
            parent_database_id
        }
    }
`

export const DATABASE_QUERY = gql`
    query Database($databaseId: String!) {
        database(database_id: $databaseId) {
            database_id
            database_name
            version
            description
            reference_genome
            created_date
            num_of_samples
            variant_count
            public
            filter_options {
                pheno_filter_options {
                    string_filters {
                        name,
                        distinct_values,
                        fraction_non_missing
                    },
                    num_filters {
                        name,
                        min_value,
                        max_value,
                        fraction_non_missing
                    },
                    bool_filters {
                        name,
                        fraction_non_missing
                    }
                },
                variant_format_filter_options {
                    string_filters,
                    num_filters,
                    bool_filters
                },
                variant_frequencies_filter_options {
                    string_filters,
                    num_filters,
                    bool_filters
                },
                variant_info_filter_options {
                    string_filters {
                        name,
                        fraction_non_missing
                    },
                    num_filters {
                        name,
                        min_value,
                        max_value,
                        fraction_non_missing
                    },
                    bool_filters {
                        name,
                        fraction_non_missing
                    }
                }
            }
        }
    }
`

export const DATABASE_LIST_QUERY = gql`
    query {
        databaseList {
            database_id
            database_name
            version
            reference_genome
            created_date
            num_of_samples
        }
    }
`

export const SEARCH_SUGGESTIONS_QUERY = gql`
    query SearchSuggestions($query: String!, $datasetId: String!) {
        searchSuggestions(query: $query, dataset_id: $datasetId) {
            variant_ids,
            gene_ids,
            gene_symbols,
            transcript_ids,
        }
    }
`

export const DELETE_DATASET = gql`
    mutation DeleteDataset($datasetId: String!) {
        deleteDataset(dataset_id: $datasetId)
    }
`

export const SET_DATASET_PUBLIC = gql`
    mutation SetDatasetPublic($datasetId: String!) {
        setDatasetPublic(dataset_id: $datasetId) {
            dataset_id
        }
    }
`

export const SET_DATASET_PRIVATE = gql`
    mutation SetDatasetPrivate($datasetId: String!) {
        setDatasetPrivate(dataset_id: $datasetId) {
            dataset_id
        }
    }
`